import React from 'react';
import { useReveal } from '../lib/useReveal';
export function ClosingSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section id="premium" className="bg-brand-alternate py-8 md:py-10 px-4 sm:px-6 border-t border-brand-border-soft" style={{
    scrollMarginTop: '80px'
  }} data-id="element-34">
      <div className="container mx-auto max-w-2xl" data-id="element-35">
        <div ref={ref1} className={`reveal text-center mb-6 ${vis1 ? 'is-visible' : ''}`} data-id="element-36">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-2 leading-tight text-brand-heading" data-id="element-37">
            ACCEDÉ A TU MEGAPACK
          </h2>
          <p className="text-brand-subheading text-base md:text-lg" data-id="element-38">
            Todo el sistema completo, en una sola compra.
          </p>
        </div>

        <div ref={ref2} className={`reveal ${vis2 ? 'is-visible' : ''}`} data-id="element-39">
          <div className="relative rounded-[20px] p-6 sm:p-10 flex flex-col bg-brand-footer border-2 border-brand-accent shadow-premium" data-id="element-40">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-cta text-white text-[10px] font-bold px-4 py-1 rounded-[6px] shadow-lg z-20 whitespace-nowrap tracking-wider" data-id="element-41">
              ⭐ OFERTA DE RELANZAMIENTO
            </div>

            <div className="text-center mb-6 mt-2" data-id="element-42">
              <h3 className="text-2xl sm:text-3xl font-serif font-bold text-white mb-2 leading-tight" data-id="element-43">
                🏆 MEGAPACK CÓDIGO FÉRTIL
              </h3>
              <p className="text-brand-border-soft font-bold text-sm mb-5" data-id="element-44">
                6 Tomos + 6 Bonos + Kit Ritual Premium
              </p>
              <div className="bg-white/10 border border-white/20 rounded-lg p-4 mb-6 text-left" data-id="element-45">
                <p className="text-brand-footer-text text-sm leading-snug" data-id="element-46">
                  <span className="font-bold text-white" data-id="element-47">Incluye:</span> El
                  método holístico completo, programa de implementación guiada
                  de 21 días, planner imprimible y rituales lunares avanzados.
                </p>
              </div>
              <div className="flex flex-col items-center justify-center" data-id="element-48">
                <span className="text-white/50 line-through text-lg font-bold" data-id="element-49">
                  $89.000
                </span>
                <p className="text-5xl sm:text-6xl font-extrabold text-white leading-none mt-1" data-id="element-50">
                  $22.990 <span className="text-2xl text-white/80" data-id="element-51">ARS</span>
                </p>
                <p className="text-brand-border-soft text-xs mt-2 tracking-wider uppercase" data-id="element-52">
                  Pago único · Acceso de por vida
                </p>
              </div>
            </div>

            <a href="https://academiaholisticaargentina.com/cart/48905855009018:1" target="_blank" rel="noopener noreferrer" className="w-full block py-5 rounded-full text-white font-bold text-sm sm:text-base tracking-widest uppercase text-center transition-all duration-300 bg-brand-cta hover:bg-brand-cta-hover shadow-medium hover:shadow-lg hover:-translate-y-1 mt-auto" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-53">
              → QUIERO MI MEGAPACK AHORA
            </a>

            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-5 text-white/70 text-xs" data-id="element-54">
              <span data-id="element-55">🔒 Pago seguro</span>
              <span data-id="element-56">⚡ Acceso en 5 min</span>
              <span data-id="element-57">🛡️ Garantía 7 días</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}